import { axiosCustomer } from 'modules/axios'
import { CONFIG } from './environments'

export function fetchOrderStatusDesc(orderStatusId, fixedStatusId) {
  axiosCustomer({
    method: 'GET',
    url: `${CONFIG.api.orderStatus}?orderStatus=${orderStatusId}&fixedLineStatus=${fixedStatusId}`,
  }).then(resp => resp.data)
}
